module.exports = __webpack_public_path__ + "static/media/joshua-earles.5af0b5e8.jpg";